import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './AdvantageItem.module.css';

type Props = {
  icon: ReactNode;
  iconPosition: 'left' | 'right';
  title: ReactNode;
  description: ReactNode;
};

export function AdvantageItem({
  icon,
  iconPosition,
  title,
  description,
}: Props) {
  return (
    <div className={cx(styles.root, styles[`icon-position_${iconPosition}`])}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
}
